import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { MembershipType } from 'src/features/membershipType/types';
import { PATH } from 'src/features/navigation/utils/constants';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellMembershipTypeActions({ row }: CellContext<MembershipType, unknown>) {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Link to={`/${PATH.ADMINISTRATION}/membership-templates/${row.original.id}`}>
                        <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                            <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                        </Button>
                    </Link>
                </TooltipTrigger>
                <TooltipContent>
                    <FormattedMessage {...generalMessages.dashboard} />
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
